import styled from 'styled-components';
import { mediaQuery } from '../../../styles/utils';

export default styled.div`
    max-width: 100%;
    margin: var(--spacing-8);

    .raf-banner-message-container {
        padding: var(--spacing-8);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: var(--font-12);
        color: var(--font-color-primary);
        background-color: var(--surface-level-1-bg);
        border: var(--surface-level-1-border);
        border-radius: var(--ui-radius);
        border-shadow: var(ui-shadow);

        @media ${mediaQuery.isPhone} {
            flex-direction: column;
        }
    }

    .link-to-deposit {
        text-align: center;
        margin-left: var(--spacing-8);
    }

    .raf-progress-bar-container {
        display: flex;
        align-items: center;
        justify-content: center;

        .wagering-progress {
            margin-left: var(--spacing-12);
            width: 250px;
        }

        .wager-requirement {
            color: var(--font-color-primary);
        }
    }
`;
